import {createStyles, Theme} from "@material-ui/core";
import {primaryColor, styleColors, typography} from "src/main.style";
import {TODO_SEEN_HIGHLIGHT_DURATION} from "@components/todo/useTodoSeen";

export const PackingListItemStyle = (theme: Theme) => createStyles({
  row: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    minHeight: '50px',
    padding: '0px 23px',
    boxSizing: 'border-box',
    position: 'relative',
    // Unseen rows carry a soft brand tint that fades out once they have been seen.
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      backgroundColor: primaryColor,
      opacity: 0,
      pointerEvents: 'none',
    },
    '@media (prefers-reduced-motion: reduce)': {
      '&$recentlySeen::before': {
        animation: 'none',
        opacity: 0,
      },
    },
  },
  unseen: {
    '&::before': {
      opacity: 0.12,
    },
  },
  recentlySeen: {
    '&::before': {
      animation: `$seenHighlight ${TODO_SEEN_HIGHLIGHT_DURATION}ms ease-out forwards`,
    },
  },
  '@keyframes seenHighlight': {
    '0%, 25%': {opacity: 0.12},
    '100%': {opacity: 0},
  },
  details: {
    flex: 1,
    minWidth: 0,
    minHeight: '50px',
    padding: '10px 0px',
    borderRadius: 0,
    justifyContent: 'flex-start',
    textAlign: 'left',
    textTransform: 'none',
    letterSpacing: 0,
    color: theme.palette.common.black,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  detailsLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minWidth: 0,
  },
  avatars: {
    display: 'flex',
    flexShrink: 0,
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
    minWidth: 0,
  },
  title: {
    ...typography.input,
    fontSize: '0.9375rem',
    letterSpacing: 0,
    overflowWrap: 'anywhere',
  },
  completedTitle: {
    textDecoration: 'line-through',
    color: styleColors.blackAlpha45,
  },
  description: {
    maxWidth: '100%',
    fontSize: '12px',
    fontWeight: 300,
    lineHeight: '16px',
    letterSpacing: 0,
    paddingTop: '2px',
    color: styleColors.greyDark1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  checkButtonRoot: {
    height: '30px',
    width: '30px',
    flexShrink: 0,
    margin: '6px 0px 6px 6px',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.grey[300],
    '&:hover': {
      backgroundColor: theme.palette.grey[400],
    },
  },
  checkButtonChecked: {
    backgroundColor: primaryColor,
    '&:hover': {
      backgroundColor: primaryColor,
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/next-handover/PackingListItem.style.ts